export const ItemNamePrefix = {
  Content: "content-entity-uuid",
  Timeline: "timeline-entity-uuid",
};
